export default __webpack_public_path__ + "static/media/mixer1.7ffaf0d9.png";